/**
 * Created by MinhQuan on 1/3/2017.
 */

angular.module('arctic.tariff.news', ['common.helper', 'pascalprecht.translate', 'taric.model.news'])
    .controller('NewsController', function (NewsModel, CONSTANTS, defaultRssFeeds) {
        var newsCtrl = this;
        newsCtrl.init = function(){
            newsCtrl.dateFormat = CONSTANTS.dateFormat;
            newsCtrl.rssFeedEntries = defaultRssFeeds.items;
        };

        newsCtrl.loadRssFeed = function(category){
            newsCtrl.loading = true;
            newsCtrl.errorCode = null;
            NewsModel.getRssFeeds(category).then(function(result){
                newsCtrl.rssFeedEntries = result.items;
                newsCtrl.loading = false;
            }, function (error) {
                newsCtrl.errorCode = "i8n.common.rss_not_reachable";
                newsCtrl.loading = false;
            });
        };
    });



// WEBPACK FOOTER //
// ./app/news/news.js